import axios from 'axios';
import { getWithRetry } from '../../misc/requests.js';
import { resourceError } from '../../misc/request-errors.js';

const PROXY_URL = process.env.VUE_APP_PROXY_URL + '/seminar-dates';
const API_URL = process.env.VUE_APP_API_URL + '/seminar-dates';

const expand = [
    'bookingIds',
    'trainers.contact',
    'seminar',
    'rooms',
];

const state = {
    hashes: {},
    seminarDate: {},
};
const getters = {
    hashes: (state) => state.hashes,
    seminarDate: (state) => state.seminarDate,
};
const actions = {
    async fetchHashes({ commit }, ids) {
        const response = await axios.get(`${PROXY_URL}/${ids.join(',')}`);
        commit('setHashes', response.data);
    },
    async fetchSeminarDate({ commit }, { hash, signal }) {
        const response = await getWithRetry(`${API_URL}/${hash}/by-hash?expand=${expand.join(',')}`, signal);
        if (response.data === null) throw resourceError('RESOURCE_NOT_FOUND');
        if (!response.data?.seminar || !Array.isArray(response.data.bookingIds)) throw resourceError('INVALID_RESPONSE');
        commit('setSeminarDate', response.data);
    }
};
const mutations = {
    setHashes: (state, hashes) => state.hashes = hashes,
    setSeminarDate: (state, seminarDate) => state.seminarDate = seminarDate,
};

export default {
    state,
    getters,
    actions,
    mutations,
}
